import { render, staticRenderFns } from "./AddGood.vue?vue&type=template&id=000ae318&scoped=true"
import script from "./AddGood.vue?vue&type=script&lang=js"
export * from "./AddGood.vue?vue&type=script&lang=js"
import style0 from "./AddGood.vue?vue&type=style&index=0&id=000ae318&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000ae318",
  null
  
)

export default component.exports